module.exports = "/dist/src/img/logo/full_logo.png";